import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import {
  Text,
  Icon,
  getRegulatoryRatingIconType
} from 'DVWebNodeUI'
import { tryCatch } from '../../utils/tryCatch'
import {
  isAmazonMaturityRatingBadge,
  isRegulatoryRatingBadge,
  isLocalRatingBadge,
} from '../../utils/ratingBadgeHelper'
import * as st from './badge.module.scss'
import { MaturityRating } from 'DVWebNodeUI'

export interface IMaturityRatingBadgeProps {
  ratingBadge?: WpsRuntime.atv.wps.RatingBadgeProps
  useNewMaturityBadges?: boolean
}

//TODO: AVWebDetailPage-2972
const ratingBadgeRender = (
  useNewMaturityBadges: boolean,
  {
    displayText,
    description,
    localRatingLink
  }:
    | WpsRuntime.atv.wps.AmazonMaturityRatingBadgeProps
    | WpsRuntime.atv.wps.RegulatoryRatingBadgeProps,
) => {
  return useNewMaturityBadges ?
    <MaturityRating rating={displayText.toUpperCase()} title={description} data-testid="rating-badge">
      {localRatingLink && (<Text string={localRatingLink} />)}
    </MaturityRating> :
    <span data-automation-id='rating-badge' className={st.borderedTextBadge} title={description}>
      {displayText.toUpperCase()}
      {localRatingLink && (' | ')}
      {localRatingLink && (<Text string={localRatingLink} />)}
    </span>
}

const getLocalRatingBadge = (
  useNewMaturityBadges: boolean,
  {
    countryCode,
    simplifiedId,
    description
  }: WpsRuntime.atv.wps.LocalRatingBadgeProps) => {
  const icon = getRegulatoryRatingIconType(countryCode, simplifiedId)
  const locale = countryCode.toLowerCase()

  return useNewMaturityBadges ?
    isValidLocale(locale) ? <MaturityRating rating={simplifiedId} locale={locale} title={description} data-testid="rating-badge" /> : null :
    icon ? <Icon use={icon} title={description} /> : null
}

const isValidLocale = (
  countryCode?: string
): countryCode is 'uk' | 'de' => {
  const acceptableLocales = ['uk', 'de']
  return Boolean(countryCode && acceptableLocales.includes(countryCode))
}

export const Rating = tryCatch(({ ratingBadge, useNewMaturityBadges = false}: IMaturityRatingBadgeProps) => {
  if (!ratingBadge) {
    return null
  }

  if (isAmazonMaturityRatingBadge(ratingBadge)) {
    return ratingBadgeRender(useNewMaturityBadges, ratingBadge)
  }

  if (isLocalRatingBadge(ratingBadge)) {
    return getLocalRatingBadge(useNewMaturityBadges, ratingBadge)
  }

  if (isRegulatoryRatingBadge(ratingBadge)) {
    return ratingBadgeRender(useNewMaturityBadges, ratingBadge)
  }

  return null
})
